import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { orderBy } from 'lodash-es';

@Pipe({
    name: 'appValues'
})
export class AppValuesPipe implements PipeTransform {
    transform<T>(value: Record<any, T>): T[] {
        return Object.values(value);
    }
}
